import clsx from "clsx";
import "./styles.css";

export function shakeEffectClassNames(shake?: boolean): string {
  return clsx({
    DLUI_shake: true,
    "shake-effect": shake
  });
}
